import { StoryblokVue, apiPlugin } from '@storyblok/vue'
import { sblokRaw } from '~/composables/useCachedStoryblok'

export default defineNuxtPlugin(({ vueApp }) => {
	const sblokFetch = async (input) => {

		const url = new URL(String(input))
		const query = Object.fromEntries(url.searchParams)
		delete query.token
		delete query.cv // /sblok cv; the client pins it for the life of the process
		console.info('!@#$%!@#$% !@#$@#$!@# -----> HELLO!!! USING sblokFetch')
		const res = await sblokRaw(url.pathname.replace(/^\/v2\//, ''), query)
		return new Response(JSON.stringify(res._data), {
			status: res.status,
			statusText: res.statusText,
			headers: res.headers,
		})
	}

	vueApp.use(StoryblokVue, {
		// placeholder proxyToken (can't give empty value).
		accessToken: 'proxyToken',
		bridge: true,
		apiOptions: { fetch: sblokFetch },
		use: [apiPlugin],
	})
})
